module.exports = __webpack_public_path__ + "img/20220219_071805.d692dead.jpg";